import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    AddIssueQuery,
    AddIssueQueryVariables,
} from './Add.queries.generated'

export const GET_ISSUE_ADD = gql`
    query AddIssue($guid: String!) {
        entity(guid: $guid) {
            guid
            ... on Magazine {
                canEdit
            }
        }
    }
` as TypedDocumentNode<AddIssueQuery, AddIssueQueryVariables>
